import React, { Component } from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Container
} from 'reactstrap';
import Logo from '../../Images/Logo.png';
// https://blog.campvanilla.com/reactjs-dropdown-menus-b6e06ae3a8fe - If we decide to get ride of reactstrap
class NavBar extends Component {
    state = {
        isOpen: false
    }
    toggle=() => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    
    }
    componentDidMount() {
        require("./css/NavBar.css");
    }
    render() {
        return(
        <div role="navigation">
            <Navbar color="light" light expand="lg" className="">
                <Container>
                    <NavbarBrand className="ml-n1 py-n1 NavHeader" href="/" >
                    {/* {this.props.Title? this.props.Title:"Matrix Healthcare"} */}
                    <img src={Logo} style={{height:"80px", width:"auto"}} alt="MatrixHC Logo"></img>
                    <div className="Nav_Logo">Matri<span style={{color:"maroon"}}>x</span> Healthcare</div>
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggle} aria-label="NavBar Dropdown"/>
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="" navbar>
                        <NavItem className="pl-3">
                            <NavLink href="/">
                                Home
                            </NavLink>
                        </NavItem>
                        <NavItem className="pl-3">
                            <NavLink href="/Members">
                                Members
                            </NavLink>
                        </NavItem>
                        <NavItem className="pl-3">
                            <NavLink href="/Employers">
                                Employers
                            </NavLink>
                        </NavItem>
                         <NavItem className="pl-3">
                            <NavLink href="/Brokers">
                                Brokers
                            </NavLink>
                        </NavItem>

                        <NavItem className="pl-3">
                            <NavLink href="/Providers">
                                Providers
                            </NavLink>
                        </NavItem>
                       
                        {/*
                        <NavItem className="pl-3">
                            <NavLink href="/Providersearch">
                                Provider Search
                            </NavLink>
                        </NavItem> */}
                        <NavItem className="pl-3">
                            <NavLink href="/About">
                                About
                            </NavLink>
                        </NavItem>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        </div>
        );
    }
}

export default NavBar;